import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

import { SidebarComponent } from '../sidebar/sidebar.component';
import { LayoutService } from '../../services/layout.service';
import { AuthService } from '../../services/auth.service';

import { BreadcrumbComponent } from '../../../shared/components/breadcrumb/breadcrumb.component';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';

import { CaseEnquiryDetailsComponent } from '../../../features/case-enquiry/case-enquiry-details/case-enquiry-details.component';
import { CaseEnquiryStateService } from '../../../features/case-enquiry/services/case-enquiry-state.service';
import { HugeiconsIconComponent } from '@hugeicons/angular';
import { Menu01Icon } from '@hugeicons/core-free-icons';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    SidebarComponent,
    BreadcrumbComponent,
    ConfirmDialogComponent,
    CaseEnquiryDetailsComponent,
    HugeiconsIconComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent implements OnInit {
  isSidebarCollapsed = false;
  userRole: string | null = null;

  // Icons
  menuIcon = Menu01Icon;

  constructor(
    private layoutService: LayoutService,
    public  enquiryState: CaseEnquiryStateService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.userRole = this.authService.getRole();

    this.layoutService.sidebarCollapsed$.subscribe(collapsed => {
      this.isSidebarCollapsed = collapsed;
    });
  }

  openMobileSidebar(): void {
    this.layoutService.toggleMobileSidebar();
  }

  closeEnquiryDetails(): void {
    this.enquiryState.clearSelection();
  }
}
